import { Box, Typography } from "@mui/material";

import { CircularProgress } from "@/Components/v2/atoms/Progress";
import { Stack } from "@/Components/v2/atoms/Stack";

export const ScenarioProcessingState = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "20rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack spacing={3} alignItems="center">
        <CircularProgress size={64} />

        <Stack spacing={1} alignItems="center">
          <Typography variant="h6" fontWeight={600}>
            Scenario is Simulating
          </Typography>

          <Typography variant="body1" color="text.secondary" textAlign="center">
            Your scenario is currently being processed. This may take a few minutes.
            <br />
            You can refresh the page to check for updates.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
